import React from 'react';
import Footer from '../../Layout/Footer';

const TermsConditions = () => {
    return (
        <>
            {/* Navigation */}
            <nav>
                <div className="nav-container">
                    <h1 className="logo">Raivens Technologies</h1>
                    <div className="nav-buttons">
                        <a href="/login" className="button button-primary">Login</a>
                        <a href="/login" className="button button-primary">Register</a>
                    </div>
                </div>
            </nav>
            <div className='common-wrap'>
                <div className='container'>
                    <h2 className='section-title mb-4'><strong>Terms of Service</strong></h2>
                    <div className='content'>
                        <p><strong>Last Updated: 18-03-2025</strong></p>
                        <p>Welcome to Raivens Technologies Pvt. Ltd. ("we", "us", "our", "Company"). By accessing and using our website wirelays.com (the "Site") and purchasing our products or services, you agree to be bound by the following Terms of Service ("Terms"). These Terms apply to all users, including browsers, vendors, customers, and contributors of content.</p>

                        <h3>1. General Conditions</h3>
                        <ul>
                            <li>You confirm that you are at least the age of majority in your region, or have parental consent to use the site.</li>
                            <li>You may not use our products or services for illegal purposes or in violation of intellectual property laws.</li>
                            <li>We reserve the right to refuse service to anyone at any time.</li>
                            <li>Your content (excluding credit card information) may be transferred unencrypted across networks, but all credit card information is encrypted during transmission.</li>
                        </ul>

                        <h3>2. Orders & Pricing</h3>
                        <ul>
                            <li>Prices are subject to change without notice.</li>
                            <li>We reserve the right to limit or refuse orders.</li>
                            <li>If an order is changed or canceled, we will attempt to notify you via email or billing address.</li>
                        </ul>

                        <h3>3. Accuracy of Information</h3>
                        <p>While we strive for accuracy in product descriptions and availability, we do not guarantee that all details, images, and colors will be error-free.</p>

                        <h3>4. Products & Services</h3>
                        <ul>
                            <li>Some products are available exclusively online with limited stock.</li>
                            <li>We reserve the right to discontinue products at any time.</li>
                            <li>We do not guarantee that product quality will meet your expectations.</li>
                        </ul>

                        <h3>5. Payment & Billing</h3>
                        <p>You agree to provide accurate and up-to-date billing information. All transactions are securely processed via third-party payment providers like Razorpay and Shopify.</p>

                        <h3>6. Shipping & Returns</h3>
                        <ul>
                            <li>Orders are processed within 12-24 hours and shipped within 3-7 business days.</li>
                            <li>Returns must be initiated within 10 days of delivery per our Refund Policy.</li>
                            <li>We are not responsible for lost or delayed shipments by carriers.</li>
                        </ul>
                        <p>📌 For more details, see our <a href="/shipping-policy">Shipping Policy</a> and <a href="/refund-policy">Refund Policy</a>.</p>

                        <h3>7. Intellectual Property Rights</h3>
                        <p>All content, trademarks, and materials on this website are owned by Raivens Technologies Pvt. Ltd. and cannot be copied or modified without permission.</p>

                        <h3>8. Third-Party Services & Links</h3>
                        <p>We are not responsible for third-party websites, their content, policies, or practices.</p>

                        <h3>9. Prohibited Uses</h3>
                        <ul>
                            <li>Illegal activities or violation of regulations.</li>
                            <li>Intellectual property infringement.</li>
                            <li>Uploading malware or engaging in fraud.</li>
                            <li>Any activity interfering with website functionality.</li>
                        </ul>
                        <p>Violations may result in service termination and legal action.</p>

                        <h3>10. Disclaimer of Warranties & Limitation of Liability</h3>
                        <ul>
                            <li>We do not guarantee uninterrupted, secure, or error-free services.</li>
                            <li>Use of this site is at your own risk; all products/services are provided "as is".</li>
                            <li>We are not liable for indirect losses, including lost data or profits.</li>
                        </ul>

                        <h3>11. Indemnification</h3>
                        <p>You agree to indemnify and hold Raivens Technologies Pvt. Ltd. harmless from claims or losses arising from your site use or Terms violation.</p>

                        <h3>12. Termination</h3>
                        <p>We reserve the right to terminate your access if you violate these Terms.</p>

                        <h3>13. Governing Law</h3>
                        <p>These Terms are governed by the laws of India.</p>

                        <h3>14. Changes to Terms of Service</h3>
                        <p>We may update these Terms at any time. Continued use of our website constitutes acceptance of the changes.</p>

                        <h3>15. Contact Information</h3>
                        <p><strong>Company Address:</strong></p>
                        <p>Raivens Technologies Pvt. Ltd.<br />Sonwa Road, Tonk, Rajasthan - 304001</p>
                        <p><strong>Shipping Address:</strong></p>
                        <p>Raivens Technologies Pvt. Ltd.<br />Plot No 4, Laxmi Vilas, Choudhary Colony, Sawai Madhopur Road, Tonk, Rajasthan, India - 304001</p>
                        <p>📧 Email: <a href="mailto:info@raivens.com">info@raivens.com</a></p>
                        <p>📞 WhatsApp: <a href="tel:+918696606662">+91 8696606662</a></p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default TermsConditions;
